import { invalidateAgentUsageMeter } from '@/features/billing-usage';
import { useAddonPurchase } from './use-addon-purchase';

/**
 * Opens the Flex recharge purchase, and refetches the agent usage meter once it
 * is bought so the readout drops back to 0%.
 */
export function useOpenFlexRecharge(): (usedPercent: number) => Promise<void> {
  const { openAddon } = useAddonPurchase();

  return async (usedPercent) => {
    const purchase = await openAddon({ request: { key: 'flex-recharge', usedPercent } });
    if (purchase != null) await invalidateAgentUsageMeter();
  };
}
